import {} from "../node/index.js";
import {} from "./Net.js";
import { copyConnectedComponent } from "./copyConnectedComponent.js";
import { createNet } from "./createNet.js";
export function findConnectedComponent(net, node) {
    const component = createNet();
    copyConnectedComponent(net, component, node);
    return component;
}
//# sourceMappingURL=findConnectedComponent.js.map